module.exports = {
  brand: {
    name: "RISEMN",
    slug: "risemn",
    tagline: "House Music DJ",
    description:
      "Underground house music for clubs and electronic music events",
  },

  api: {
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:4041",
    timeout: 30000,
  },

  branding: {
    primaryColor: "#FF6B35",
    secondaryColor: "#2E294E",
    accentColor: "#1B998B",
    quaternaryColor: "#C5D86D",
    gradients: {
      primary: "linear-gradient(-45deg, #FF6B35, #2E294E, #1B998B, #C5D86D)",
      card: "linear-gradient(-45deg, #FF6B35, #2E294E, #1B998B, #C5D86D)",
    },
    logo: "/logo.png",
    favicon: "/favicon.ico",
  },

  theme: {
    mode: "dark",
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontSize: "2.5rem", fontWeight: 600 },
      h2: { fontSize: "2rem", fontWeight: 600 },
      h3: { fontSize: "1.5rem", fontWeight: 500 },
    },
  },

  features: {
    audio: true,
    gallery: true,
    reviews: false,
    events: true,
    adminPanel: true,
  },

  navigation: {
    items: [
      { name: "Home", path: "/", icon: "home" },
      { name: "Audio", path: "/audio", icon: "audiotrack" },
      { name: "Gallery", path: "/gallery", icon: "photo_library" },
      { name: "Events", path: "/events", icon: "event" },
      { name: "Booking", path: "/booking", icon: "book_online" },
    ],
  },

  social: {
    instagram: {
      url: "https://www.instagram.com/risemnmusic",
    },
    facebook: {
      url: "https://www.facebook.com/andrewrisedj",
    },
    soundcloud: {
      url: "https://soundcloud.com/risemnmusic",
    },
    youtube: {
      url: "https://www.youtube.com/@risemnmusic",
    },
  },

  domains: {
    frontend: process.env.REACT_APP_FRONTEND_URL || "http://localhost:3001",
    production: "https://www.risedj.club",
  },
};
